import { isBrowserSupported } from 'helpers/browser';

import { BASE_WEBSITE_URL } from 'services/api';

if (!isBrowserSupported()) {
  window.location.assign(`${BASE_WEBSITE_URL}/unsupportedBrowser.html`);
}
